import InterstitialScreen from "./InterstitialScreen";
import NextStepButton from "../shared/NextStepButton";
import { AlertTriangle } from "lucide-react";

type Props = {
  translate?: (keyString: string, fallbackString: string) => string;
  onExit?: () => void;
};

const TryAgainLaterScreen = ({ translate, onExit }: Props) => {
  return (
    <InterstitialScreen
      onExit={onExit}
      centralIcon={<AlertTriangle color="#080808" size={64} />}
      text={
        translate
          ? translate(
              "default-crash-error-text",
              "We encountered an unexpected error"
            )
          : "We encountered an unexpected error"
      }
      subText={
        translate
          ? translate(
              "default-crash-error-subtext",
              "Please try again later"
            )
          : "Please try again later"
      }
      bottomAction={
        <NextStepButton
          onClick={() => {
            if (onExit) {
              onExit();
            } else {
              window.parent.postMessage({ messageType: "CLOSE_LINKING_FLOW" }, "*");
            }
          }}
          inverted
        >
          {translate ? translate("default-close-window", "Close window") : "Close window"}
        </NextStepButton>
      }
    />
  );
};

export default TryAgainLaterScreen;
